import { useState } from "react";
import styled from "styled-components";
import { IoMdLogOut } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Divider, IconButton, Tooltip } from "@mui/material";

import pages from "../../constants/pages";
import cashkaro from "../../assets/cashkaro_logo_v1.svg";
import { colors } from "../../pages/css components/Style";
import {
  setActiveBrand,
  signInMember,
  signOutMember,
} from "../../redux/slices/memberSlice";
import { PrimaryLoadingButton } from "../../pages/css components/Button";
import dashboardLayoutRoutes from "../../router/router components/dashboardLayoutRoutes";

const Wrapper = styled.div`
  min-height: 80px;
  border-radius: 0px;
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 5px 5px -5px rgba(35, 37, 38, 0.15);
`;

const BrandDiv = styled.div`
  display: flex;
`;

const ImageDiv = styled.div`
  width: 150px;
  height: 40px;
`;

const Image = styled.img`
  height: inherit;
  width: inherit;
`;

const IconDiv = styled.div`
  display: flex;
  align-self: center;
`;

export default function Navbar({ setSelectedMenu }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const uiDetails = useSelector((state) => state.renderUIDetails);

  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const agencyID =
    useSelector((state) => state?.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  const userID = sessionStorage.getItem("userID");
  const businessEntityID = sessionStorage.getItem("businessEntityId");
  const { dashboardPermissions } = useSelector((state) => state.memberDetails);

  const isAgencyVerified =
    useSelector((state) => state.memberDetails?.agency?.isAgencyVerified) ||
    sessionStorage.getItem("is_agency_verified");

  return (
    <Wrapper>
      <IconDiv>
        <ImageDiv
          onClick={() => {
            const isAdminBrand = dashboardPermissions.some(
              (page) => page.ID === "administrator-brands"
            );

            const path = isAdminBrand
              ? pages.accountVerification.route
              : pages.brandDetails.route;

            navigate(path);
            setSelectedMenu(path);
          }}
        >
          <Image src={cashkaro} alt="!" />
        </ImageDiv>
      </IconDiv>

      <BrandDiv>
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          {parseInt(isAgencyVerified) === 1 && (
            <PrimaryLoadingButton
              loading={loading}
              style={{ float: "left" }}
              variant="outlined"
              onClick={() => addNewBrand()}
            >
              Add Brand
            </PrimaryLoadingButton>
          )}

          <Divider
            orientation="vertical"
            flexItem
            style={{ height: "50px", margin: "0 10px" }}
          />
          <Tooltip title="Logout">
            <IconButton
              style={{ border: `1px solid ${colors.error}` }}
              onClick={() => dispatch(signOutMember())}
            >
              <IoMdLogOut color={colors.error} />
            </IconButton>
          </Tooltip>
        </div>
      </BrandDiv>
    </Wrapper>
  );

  async function handleAgency() {
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
      })
    );

    navigate(
      dashboardLayoutRoutes.agencyDetailsRoute.path + "?agencyID=" + agencyID
    );
  }

  async function addNewBrand() {
    setLoading(true);
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
      })
    );
    dispatch(
      setActiveBrand({
        ID: "",
        about: "",
        brandName: "",
        logo: "",
        languages: [],
        locations: [],
        category: [],
        mau: "",
        onlineStore: "",
        website: "",
        socialMedia: {},
        brandType: "",
      })
    );
    setLoading(false);
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true);
  }
}
